import { render, staticRenderFns } from "./TodaysAdviceAppointments.vue?vue&type=template&id=1d2ea514"
import script from "./TodaysAdviceAppointments.vue?vue&type=script&lang=js"
export * from "./TodaysAdviceAppointments.vue?vue&type=script&lang=js"
import style0 from "./TodaysAdviceAppointments.vue?vue&type=style&index=0&id=1d2ea514&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports